import axios from "axios";
import Swal from "sweetalert2";

export const getStoresStats = async () => {
  try {
    const brear = localStorage.getItem("token");
    console.log("brear", brear);
    const lang = localStorage.getItem("i18nextLng");
    const { data } = await axios.get("/v1/admin/stores/stats", {
      headers: {
        Authorization: "Bearer " + `${brear}`,
        app_key: "3D3AhWezABN8DRoPO0VEtP6nq4iDBhKm35E7FlDj",
        lang: lang,
      },
    });
    return data;
  } catch (error) {
    throw error;
  }
};

export const getStores = async (currentPage ,filters ,type) => {
  try {
    console.log('type', type)
    const brear = localStorage.getItem("token");
    console.log("brear", brear);
    const lang = localStorage.getItem("i18nextLng");
    const { data } = await axios.get("/v1/admin/stores", {
      params:{
        page:currentPage ,
        ...filters ,
        main :type === "branch" ? 1 : 0
      },
      headers: {
        Authorization: "Bearer " + `${brear}`,
        app_key: "3D3AhWezABN8DRoPO0VEtP6nq4iDBhKm35E7FlDj",
        lang: lang,
      },
    });
    return data;
  } catch (error) {
    throw error;
  }
};

export const showStores = async (id ,selectedLangCode) => {
  try {
    const brear = localStorage.getItem("token");
    console.log("brear", brear);
    let lang = localStorage.getItem("i18nextLng");
    if(selectedLangCode ){
          lang = selectedLangCode
    }
    const { data } = await axios.get(`/v1/admin/stores/${id}`, {
      params: {
        lang: lang,
      },
      headers: {
        Authorization: "Bearer " + `${brear}`,
        app_key: "3D3AhWezABN8DRoPO0VEtP6nq4iDBhKm35E7FlDj",
        "Accept-Language": lang,
      },
    });
    return data;
  } catch (error) {
    throw error;
  }
};

export const getStoreBranches = async (id ,page ,all) => {
  try {
    const brear = localStorage.getItem("token");
    const lang = localStorage.getItem("i18nextLng");
    const { data } = await axios.get(`/v1/admin/stores/${id}/branches`, {
      params: {
        page: page,
    
        all
      },
      headers: {
        Authorization: "Bearer " + `${brear}`,
        app_key: "3D3AhWezABN8DRoPO0VEtP6nq4iDBhKm35E7FlDj",
        lang: lang,
      },
    });
    return data;
  } catch (error) {
    throw error;
  }
};

export const postStores = async (postData) => {
  try {
    const brear = localStorage.getItem("token");
    console.log("brear", brear);
    const lang = localStorage.getItem("i18nextLng");
    const { data } = await axios.post("/v1/admin/stores", postData, {
      headers: {
        Authorization: "Bearer " + `${brear}`,
        app_key: "3D3AhWezABN8DRoPO0VEtP6nq4iDBhKm35E7FlDj",
        lang: lang,
      },
    });
    return data;
  } catch (error) {
    throw error;
  }
};



export const importExcelStores = async (file) => {
  try {
    const bearer = localStorage.getItem("token");
    const lang = localStorage.getItem("i18nextLng");

    const formData = new FormData();
    formData.append("file", file);

    const { data } = await axios.post(
      "/v1/admin/stores-import",
      formData,
      {
        headers: {
          Authorization: `Bearer ${bearer}`,
          app_key: "3D3AhWezABN8DRoPO0VEtP6nq4iDBhKm35E7FlDj",
          lang,
          "Content-Type": "multipart/form-data",
        },
      }
    );

    return data;
  } catch (error) {
    throw error?.response?.data || error;
  }
};


export const exportExcelStores = async () => {
  try {
    const bearer = localStorage.getItem("token");
    const lang = localStorage.getItem("i18nextLng");

    const response = await axios.get(
      "/v1/admin/stores-export",

      {
      
        headers: {
          Authorization: `Bearer ${bearer}`,
          app_key: "3D3AhWezABN8DRoPO0VEtP6nq4iDBhKm35E7FlDj",
          lang,
        },
      }
    );

    return response.data;
  } catch (error) {
    throw error?.response?.data || error;
  }
};


export const updateStore = async (postData, id) => {
  try {
    const brear = localStorage.getItem("token");
    const lang = localStorage.getItem("i18nextLng");
    const { data } = await axios.post(`/v1/admin/stores/${id}`, postData, {
      headers: {
        Authorization: "Bearer " + `${brear}`,
        app_key: "3D3AhWezABN8DRoPO0VEtP6nq4iDBhKm35E7FlDj",
        lang: lang,
      },
    });
    return data;
  } catch (error) {
    throw error;
  }
};

export const deleteStores = async (id,lang) => {
  const brear = localStorage.getItem("token");
  const result = await Swal.fire({
    title: "هل انت متأكد ؟",
    text: "سيتم الحذف",
    icon: "warning",
    showCancelButton: true,
    cancelButtonColor: "#d33",
    confirmButtonText: "Okay",
  });
  if (result.isConfirmed) {
    try {
      const { data } = await axios.delete(`/v1/admin/stores/${id}`, {
        headers:{
        Authorization: "Bearer " + `${brear}`,
        app_key: "3D3AhWezABN8DRoPO0VEtP6nq4iDBhKm35E7FlDj",
        lang: lang,
        }

      });
      if (data.success === true) {
        Swal.fire("Deleted!", `${data.message}`, "success");
      } else {
        Swal.fire("Not deleted", `${data.message}`, "info");
      }
      return data;
    } catch (error) {
      throw error;
    }
  }
};
